var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
